import { toast } from "react-toastify";
import { formatString } from "./utils";

let lastShownMsg = "";
let lastShownType = "";
let timeoutId: any = null;

const reset = () => {
  lastShownMsg = "";
  lastShownType = "";
  timeoutId = null;
};

export const livisAlert = (message = "Invalid Request", msg_type = "info", duration = 5000) => {
  const msg = formatString(message);
  if (timeoutId) {
    // An alert is already on screen / in the ignore window — do not stack another one.
    return;
  }

  // Suppress repeated identical alerts
  if (msg === lastShownMsg && msg_type === lastShownType) {
    timeoutId = setTimeout(reset, 2000);
    return;
  }

  lastShownMsg = msg;
  lastShownType = msg_type;

  toast(msg, {
    type: msg_type === "success" || msg_type === "error" || msg_type === "warning" ? msg_type : "info",
    icon: true,
    position: "top-right",
    autoClose: duration,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });

  // Block any further alerts for a short window so multiple toasts don't stack at once.
  timeoutId = setTimeout(reset, Math.min(duration, 2000));
};
